<div class="main-container">
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title">Add Dispatch Devices</span>
    </div>
  </div>

  @if (isUploadBoxVisible) {
    <div class="component-container">
      <form [formGroup]="addDispatchDeviceForm" novalidate>
        <div class="component-header">
          <h6 class="component-title">Dispatch Devices</h6>
          <div class="component-actions">
            <button
              class="primary-button"
              type="button"
              (click)="downloadMyFile()"
            >
              Download Sample<mat-icon class="btn-icon">download</mat-icon>
            </button>
          </div>
        </div>
        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>
        <div class="component-body">
          <div class="form-section">
            <div class="form-group">
              <label for="file" class="form-label"
                >Upload Dispatch Device File</label
              >
              <mat-form-field
                class="file-upload-container"
                appearance="outline"
              >
                <mat-label>Upload Dispatch Device File</mat-label>

                <!-- Display File Name or Placeholder -->
                <input matInput type="text" formControlName="file" readonly />

                <!-- Hidden File Input -->
                <input
                  type="file"
                  accept=".xls,.xlsx"
                  aria-label="File"
                  class="d-none"
                  (change)="onFileChange($event)"
                  #fileInput
                />

                <!-- Custom Upload Button -->
                <button
                  mat-button
                  class="upload-btn"
                  (click)="fileInput.click()"
                  type="button"
                >
                  <mat-icon>attach_file</mat-icon>
                </button>

                @if (
                  addDispatchDeviceForm.controls['file'].touched &&
                  addDispatchDeviceForm.controls['file'].errors?.required
                ) {
                  <mat-error> This field is mandatory. </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="component-separator"></div>
        <div class="component-footer">
          <div class="button-group">
            <button
              class="submit-button"
              (click)="saveDeviceDetails()"
              [disabled]="!fileUploaded"
            >
              Submit <mat-icon class="btn-icon">check_circle</mat-icon>
            </button>
          </div>
        </div>
      </form>
    </div>
  }

  @if (!isUploadBoxVisible) {
    <!-- Uploaded Dispatch Device List -->
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">Uploaded Dispatch Device List</h6>
        <div class="component-actions">
          <div class="component-actions">
            <button
              class="primary-button"
              [disabled]="dispatchUploadedDeviceList.length === 0"
              (click)="
                exportToExcelUploadedDispatchedDeviceData(
                  dispatchUploadedDeviceList
                )
              "
              value="excel"
            >
              Export Uploaded Devices<mat-icon class="btn-icon"
                >download</mat-icon
              >
            </button>
          </div>
        </div>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>Device UID</th>
              <th>Customer Name</th>
              <th>Customer Part Number</th>
              <th>Remark</th>
            </tr>
          </thead>
          @if (dispatchUploadedDeviceList.length > 0) {
            <tbody>
              @for (
                item of dispatchUploadedDeviceList
                  | paginate
                    : {
                        id: 'paginateUpload',
                        itemsPerPage: dispatchUploadedDeviceSize,
                        currentPage: dispatchUploadedDevicePage,
                        totalItems: dispatchUploadedDeviceList.length,
                      };
                track item
              ) {
                <tr>
                  <td>{{ item.uid }}</td>
                  <td>{{ item.customerName }}</td>
                  <td>{{ item.customerPartNumber }}</td>
                  <td>{{ item.result }}</td>
                </tr>
              }
            </tbody>
          } @else {
            <tbody>
              <tr>
                <td colspan="5">
                  <img
                    loading="lazy"
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <div class="component-separator"></div>
      <div class="component-footer">
        @if (dispatchUploadedDeviceList.length > 0) {
          <app-common-component-pagination
            [totalItems]="dispatchUploadedDeviceList.length"
            [pageSize]="dispatchUploadedDeviceSize"
            [currentPage]="dispatchUploadedDevicePage"
            (pageChange)="onPageChangeDispatchInvalidDeviceList($event)"
            (sizeChange)="onSizeChangeDispatchInvalidDeviceList($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>

    <!-- Duplicate Device List -->
    <!-- <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">Duplicate Dispatch Device List</h6>
        <div class="component-actions">
          <div class="component-actions">
            <button
              class="primary-button"
              [disabled]="dispatchDuplicateDeviceList.length === 0"
              (click)="
                exportToExcelDuplicateDispatchedDeviceData(
                  dispatchDuplicateDeviceList
                )
              "
              value="excel"
            >
              Export Duplicate Devices<mat-icon class="btn-icon"
                >download</mat-icon
              >
            </button>
          </div>
        </div>
      </div> -->
    <!-- Separator between Header and Body -->
    <!-- <div class="component-separator"></div> -->
    <!-- Component Body Section -->
    <!-- <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>Device UID</th>
              <th>Customer Name</th>
              <th>Customer Part Number</th>
              <th>Remark</th>
            </tr>
          </thead>
          @if (dispatchDuplicateDeviceList.length > 0) {
            <tbody>
              @for (
                item of dispatchDuplicateDeviceList
                  | paginate
                    : {
                        id: 'batchPaginateDispatchDuplicateDeviceList',
                        itemsPerPage: dispatchDuplicateDeviceSize,
                        currentPage: dispatchDuplicateDevicePage,
                        totalItems: dispatchDuplicateDeviceList.length,
                      };
                track item
              ) {
                <tr>
                  <td>{{ item.uid }}</td>
                  <td>{{ item.customerName }}</td>
                  <td>{{ item.customerPartNumber }}</td>
                  <td>
                    <ul>
                      @for (error of item.errors; track error) {
                        <li>{{ error }}</li>
                      }
                    </ul>
                  </td>
                </tr>
              }
            </tbody>
          } @else {
            <tbody>
              <tr>
                <td colspan="5">
                  <img
                    loading="lazy" class="no-data-img" src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <div class="component-separator"></div>
      <div class="component-footer">
        @if (dispatchDuplicateDeviceList.length > 0) {
          <app-common-component-pagination
            [totalItems]="dispatchDuplicateDeviceList.length"
            [pageSize]="dispatchDuplicateDeviceSize"
            [currentPage]="dispatchDuplicateDevicePage"
            (pageChange)="onPageChangeDispatchDuplicateDeviceList($event)"
            (sizeChange)="onSizeChangeDispatchDuplicateDeviceList($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div> -->

    <!-- Invalid Device List -->
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">Invalid Dispatch Device List</h6>
        <div class="component-actions">
          <div class="component-actions">
            <button
              class="primary-button"
              [disabled]="dispatchInvalidDeviceList.length === 0"
              (click)="
                exportToExcelInvalidDispatchedDeviceData(
                  dispatchInvalidDeviceList
                )
              "
              value="excel"
            >
              Export Invalid Devices<mat-icon class="btn-icon"
                >download</mat-icon
              >
            </button>
          </div>
        </div>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>Device UID</th>
              <th>Customer Name</th>
              <th>Customer Part Number</th>
              <th>Remark</th>
            </tr>
          </thead>
          @if (dispatchInvalidDeviceList.length > 0) {
            <tbody>
              @for (
                item of dispatchInvalidDeviceList
                  | paginate
                    : {
                        id: 'paginateInvalid',
                        itemsPerPage: dispatchInvalidDeviceSize,
                        currentPage: dispatchInvalidDevicePage,
                        totalItems: dispatchInvalidDeviceList.length,
                      };
                track item
              ) {
                <tr>
                  <td>{{ item.uid }}</td>
                  <td>{{ item.customerName }}</td>
                  <td>{{ item.customerPartNumber }}</td>
                  <td>{{ item.result }}</td>
                </tr>
              }
            </tbody>
          } @else {
            <tbody>
              <tr>
                <td colspan="5">
                  <img
                    loading="lazy"
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <div class="component-separator"></div>
      <div class="component-footer">
        @if (dispatchInvalidDeviceList.length > 0) {
          <app-common-component-pagination
            [totalItems]="dispatchInvalidDeviceList.length"
            [pageSize]="dispatchInvalidDeviceSize"
            [currentPage]="dispatchInvalidDevicePage"
            (pageChange)="onPageChangeDispatchInvalidDeviceList($event)"
            (sizeChange)="onSizeChangeDispatchInvalidDeviceList($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>
  }
</div>
